<template>
  <div class="page-scanner">
  <scanner @ready="scanner_ready" @scanned="qr_scanned" ref="scanner"></scanner>
  <usermodal :timeout="3" v-model="user" @close="hide_modal" ref="usermodal"></usermodal>
  <loader-bar @ended="loader_end" ref="loader" :timeout="15"></loader-bar>
  <div v-if="status == 'success'" class="scan-status scan-status__success"></div>
  <div v-if="status == 'error'" class="scan-status scan-status__danger"></div>
  </div>
</template>
<script type="text/javascript">
  import Scanner from './../components/Scanner.vue'
  import Usermodal from './../components/Usermodal.vue'
  import LoaderBar from './../components/LoaderBar.vue'
  import kiosk from './../classes/kiosk'
  import helper from './../classes/helper'
  import {Howl, Howler} from 'howler';

  export default {
    components: {
      Scanner,
      Usermodal,
      LoaderBar,
    },
    data: function(){
      return {
        showmodal: false,
        user: {
          name: ''
        },
        status: null,
        status_timer: null,
        pairing: null
      }
    },
    mounted: function () {
      kiosk.pairing().then(pairing => { this.pairing = pairing; });
    },
    methods: {
      scanner_ready: function(){
        this.$refs.loader.start();
      },
      loader_end: function(){
        this.$refs.scanner.stopStream();
        helper.reset_can_scan();
        this.$router.push({ name: 'home'});
      },
      hide_modal: function(){
        this.$refs.loader.start();
      },
      qr_scanned: function(data){
        var self = this;

        // A badge QR carries an integer user id; anything else could never be
        // recorded, so it is refused here instead of queued.
        if (!data || typeof data.account == 'undefined' || !Number.isInteger(Number(data.id)) || data.id === null || data.id === '') {
          self.showStatus('error');
          return;
        }

        if (!self.pairing || String(data.account) !== String(self.pairing.account_id)) {
          self.user = { name: data.name, error: 'Deze badge hoort bij een ander bedrijf.' };
          self.$refs.usermodal.show();
          self.showStatus('error');
          return;
        }

        if (!helper.check_can_scan(data)) {
          self.showStatus('error');
          return;
        }

        if (self.$refs.usermodal) {
          self.$refs.usermodal.close();
        }
        this.$refs.loader.stop();

        kiosk.record(data).then(function (result) {
          if (result && result.status === 'rejected') {
            self.user = { name: data.name, error: 'Deze badge is niet gekend. Vraag een planner om hulp.' };
            self.$refs.usermodal.show();
            self.showStatus('error');
            return;
          }

          self.user = { name: data.name, type: result ? result.type : null, time: result ? result.badged_at : null };
          self.$refs.usermodal.show();
          self.showStatus('success');
          new Howl({ src: ['beep.mp3'] }).play();

          if (!result && 'serviceWorker' in navigator && 'SyncManager' in window) {
            navigator.serviceWorker.ready.then(sw => sw.sync.register('sync-new-badges'));
          }
        });
      },
      showStatus: function(status){
        var self = this;
        if (this.status_timer) {
          clearTimeout(this.status_timer);
        }

        this.status = status;

        this.status_timer = setTimeout(() => {
          self.status = null;
        }, 1000);
      }
    }
  };
</script>
